import axios from '@/axios'

const find = id => {
	const path = `orders?id=${id}`
	return axios.get(path)
}

const getAll = ({
	sorting: { field, order },
	perPage = 10,
	pageNr = 1,
	filter,
	searchText,
	// where: { whereField, whereCondition, whereValue }
	where = []
}) => {
	let filterSegment = ''
	let searchSegment = ''
	let whereSegment = ''

	if (filter) {
		if (typeof filter.value === 'boolean') filterSegment += `&${filter.by}[exists]=${filter.value}`
		else if (Array.isArray(filter.value))
			filter.value.forEach(value => {
				filterSegment += `&${filter.by}[]=${value}`
			})
		else filterSegment += `&${filter.by}=${filter.value}`
	}

	// whereParams = {
	// 	whereField: 'montageDate',
	// 	whereCondition: 'strictly_before',
	// 	whereValue: moment()
	// 		.add(14, 'days')
	// 		.format('YYYY-MM-DD')
	// }

	// if (whereField) {
	// 	whereSegment = `&${whereField}[${whereCondition}]=${whereValue}`
	// }
	// if (where.length) {
	// 	where.forEach(({ whereField, whereCondition, whereValue }) => {
	// 		whereSegment += `&${whereField}[${whereCondition}]=${whereValue}`
	// 	})
	// }
	if (where.length) {
		where.forEach(({ whereField, whereValue }) => {
			whereSegment += `&${whereField}=${whereValue}`
		})
	}

	if (searchText) searchSegment = `&search=${searchText}`

	let path = `orders?order[${field}]=${order}&itemsPerPage=${perPage}&page=${pageNr}`
	if (filterSegment) path += filterSegment
	if (searchSegment) path += searchSegment
	if (whereSegment) path += whereSegment

	return axios.get(path)
}

const update = order => {
	const path = `orders/${order.id}`
	const orderToUpdate = { ...order }

	if (orderToUpdate.route) orderToUpdate.route = `/api/routes/${orderToUpdate.route.id}`
	if (orderToUpdate.image) orderToUpdate.image = orderToUpdate.image['@id']
	if (orderToUpdate.creator) delete orderToUpdate.creator
	if (orderToUpdate.logs) delete orderToUpdate.logs
	if (orderToUpdate.isInvoiceSent === null) delete orderToUpdate.isInvoiceSent
	if (orderToUpdate.isInvoicePaid === null) delete orderToUpdate.isInvoicePaid

	return axios.put(path, orderToUpdate)
}

const create = order => {
	const path = `orders`
	if (order.creator) delete order.creator
	return axios.post(path, order)
}

const destroy = order => {
	const path = `orders/${order.id}`
	return axios.delete(path)
}

const sendEmail = data => {
	const path = `send-email`
	return axios.post(path, data)
}

// const assignToRoute = order => {
//   const path = `orders/${order.id}`
//   return axios.put(path, { route})
// }

export default {
	find,
	getAll,
	create,
	update,
	destroy,
	sendEmail
}
